import { StyleSheet } from 'aphrodite';
import { baseStyleSheet } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	bold: {
		...baseStyleSheet.fontBold,
	},
	cancelOnReplyCheckbox: {
		marginTop: 35,
	},
	cancelOnReplyCheckboxText: {
		width: 500,
	},
	checkboxText: {
		color: '#4a4a4a',
		fontSize: 14,
		marginBottom: 2,
		marginLeft: 16,
		width: 300,
	},
	daysBetweenInput: {
		textAlign: 'center',
		width: 30,
	},
	daysBetweenTextInput: {
		margin: '0 5px',
	},
	eventRegistrationTriggerDisclaimer: {
		marginTop: 20,
	},
	searchBox: {
		backgroundColor: '#f9f9f9',
		color: '#4a4a4a',
		display: 'inline-block',
		fontSize: 14,
		height: 40,
		outline: 'none',
		verticalAlign: 'middle',
		width: 458,
	},
	textingTriggerCheckboxText: {
		width: 458,
	},
	triggerSelect: {
		marginTop: 14,
		maxWidth: '100%',
		width: '100%',
	},
	triggerSettingsCheckbox: {
		marginTop: 14,
	},
	triggerSettingsCheckboxText: {
		margin: 0,
		minWidth: 400,
	},
	triggerSettingsTitle: {
		marginBottom: 20,
	},
	triggerSettingsWarning: {
		marginLeft: 27,
		marginRight: 27,
		marginTop: 10,
	},
	repeatedRunsDaysInput: {
		marginLeft: 27,
		marginTop: 10,
		display: 'flex',
		alignItems: 'center',
		gap: 10,
		color: '#4a4a4a',
		fontSize: 14,
	},
});
